import { OBJECT_TYPES } from "appConstants";

export function beforeSave(record) {
  const newRecord = { ...record };
  newRecord.locationId = record.location?.id || "0";

  if (newRecord.objectType?.id !== OBJECT_TYPES.ITEM.fullString) {
    // location and date are only used on item imports
    delete newRecord.locationId;
    delete newRecord.date1;
  }
  delete newRecord.location;
  delete newRecord.objectType;
  return newRecord;
}
